import Phaser from 'phaser';
import { WORLD } from './world.ts';
import { sound } from './audio/sound.ts';
import { BootScene } from './scenes/BootScene.ts';
import { TitleScene } from './scenes/TitleScene.ts';
import { SelectScene } from './scenes/SelectScene.ts';
import { WorkshopScene } from './scenes/WorkshopScene.ts';
import { HelpScene } from './scenes/HelpScene.ts';
import { TournamentScene } from './scenes/TournamentScene.ts';
import { BattleScene } from './scenes/BattleScene.ts';
import { ResultsScene } from './scenes/ResultsScene.ts';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  width: WORLD.width,
  height: WORLD.height,
  backgroundColor: '#05060a',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: 0 },
      enableSleeping: false,
      debug: false,
    },
  },
  scene: [
    BootScene,
    TitleScene,
    SelectScene,
    WorkshopScene,
    HelpScene,
    TournamentScene,
    BattleScene,
    ResultsScene,
  ],
};

const game = new Phaser.Game(config);

// Expose for headless smoke tests (harmless in normal play).
(window as unknown as { __GAME__: Phaser.Game }).__GAME__ = game;

// Audio: create/resume on the first gesture (browser autoplay policy); M mutes.
window.addEventListener('keydown', (e) => {
  sound.ensure();
  if (e.key.toLowerCase() === 'm') sound.toggleMute();
});
window.addEventListener('pointerdown', () => sound.ensure());
